let timer;
export default class Debounce {
  debounce = ({ debounce, debounceTimeout = 1000 }) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      debounce();
    }, debounceTimeout);
  };
}
